import { Outlet } from 'react-router-dom';
import { PAGE_VIEW } from '@bo-constants/analytics/pageViews';
import { useAnalyticsPageViews } from '@bo-hooks/analytics';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';
import { withProfiler } from '@sentry/react';

export const PlayerPacksDashboardView = () => {
  useSentrySetDashBoardTag({ dashboardName: 'Player Packs' });
  useAnalyticsPageViews({ pageViewKey: PAGE_VIEW.PLAYER_PACKS });

  return <Outlet />;
};

export const PlayerPacksDashboard = withProfiler(PlayerPacksDashboardView);
